<template lang="pug" src="./custom-patients-faq.pug"></template>

<script>
import { onScroll } from 'resources/mixins'

export default {
  data () {
    return {
      activeTab: null,
      open: false,
      maxHeight: 0,
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.25]
      }
    }
  },
  props: ['props'],
  mixins: [onScroll],
  methods: {
    handleClick (i) {
      if (this.activeTab === i) {
        this.open = false
        this.activeTab = null
      } else {
        this.open = true
        this.activeTab = i
      }
      setTimeout(() => {
        this.maxHeight = this.$refs.wrapper[i].clientHeight
      }, 50)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-patients-faq/custom-patients-faq.vue